import React from 'react';

import { Route, Routes } from 'react-router-dom';

import {
  Admin,
  NewAccommodation,
  EditAccommodation,
  Universities,
  Logos,
  ListAccommodations,
  Users,
  NotFound,
  Countries,
  Destinations,
  Leads,
  Home,
  Wizard,
  Profile,
  Login,
} from '../pages/index';
import Forgot from '../pages/Login/forgot';
import Reset from '../pages/Login/reset';

import DefaultLayout from './DefaultLayout';

function RoutesApp() {
  return (
    <Routes>
      <Route
        path=""
        element={
          <DefaultLayout>
            <Home />
          </DefaultLayout>
        }
      />
      <Route
        path="login"
        element={
          <DefaultLayout>
            <Login />
          </DefaultLayout>
        }
      />
      <Route
        path="profile"
        element={
          <DefaultLayout>
            <Profile />
          </DefaultLayout>
        }
      />
      <Route
        path="wizard/:type"
        element={
          <DefaultLayout>
            <Wizard />
          </DefaultLayout>
        }
      />
      <Route
        path="forgot"
        element={
          <DefaultLayout>
            <Forgot />
          </DefaultLayout>
        }
      />
      {/* example url: http://localhost:3001/reset-password?token=5d1c2cebeb72a94a996303203cc5cf8fcc44c0cd */}
      <Route
        path="reset-password"
        element={
          <DefaultLayout>
            <Reset />
          </DefaultLayout>
        }
      />
      <Route
        path="page/*"
        element={
          <DefaultLayout>
            <ListAccommodations />
          </DefaultLayout>
        }
      />
      <Route
        path="accommodations"
        element={
          <DefaultLayout>
            <ListAccommodations />
          </DefaultLayout>
        }
      />
      <Route path="admin">
        <Route
          index
          element={
            <DefaultLayout>
              <Admin />
            </DefaultLayout>
          }
        />
        <Route
          path="new-accommodation"
          element={
            <DefaultLayout>
              <NewAccommodation />
            </DefaultLayout>
          }
        />
        <Route
          path="edit-accommodation/:id"
          element={
            <DefaultLayout>
              <EditAccommodation />
            </DefaultLayout>
          }
        />
        <Route
          path="universities"
          element={
            <DefaultLayout>
              <Universities />
            </DefaultLayout>
          }
        />
        <Route
          path="logos"
          element={
            <DefaultLayout>
              <Logos />
            </DefaultLayout>
          }
        />
        <Route
          path="users"
          element={
            <DefaultLayout>
              <Users />
            </DefaultLayout>
          }
        />
        <Route
          path="countries"
          element={
            <DefaultLayout>
              <Countries />
            </DefaultLayout>
          }
        />
        <Route
          path="destinations"
          element={
            <DefaultLayout>
              <Destinations />
            </DefaultLayout>
          }
        />
        <Route
          path="leads"
          element={
            <DefaultLayout>
              <Leads />
            </DefaultLayout>
          }
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default RoutesApp;
